import filterActions from '../actions/filter.actions';

const filterReducer = (state, action) => {
  switch (action.type) {
    case filterActions.FILTER_CHANGED_SUCCESS:
      return Object.assign({}, { ...state }, { filterChanged: true });
    default:
      return state;
  }
};

export default filterReducer;
